import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Popup from '../components/Popup'
import {
	publishJob
} from '../actions'

export default class AddJob extends Component {

  constructor(props) {
    super(props)
    this.state = {
      opened: props.opened || false
    };
	}

	publishJob = () => {
		const postToSave = {title: this.title.value,
			company: this.company.value,
			description: this.description.value,
			url: this.url.value,
			sponsored: true
		};
		return this.props.dispatch(publishJob(postToSave));
	}

  render() {
		const { post, opened } = this.props
    return (
			<Popup opened={opened} onClick={this.props.onClick} render={(children) => (
				<div>
					<h2>Enter job details</h2>
					<input type="text" name="title" ref={input => this.title = input} placeholder="Job title" />
					<input type="text" name="company" ref={input => this.company = input} placeholder="Company" />
					<textarea rows="15" name="description" ref={input => this.description = input} cols="70" placeholder="Job description"></textarea>
					<input type="text" name="url" ref={input => this.url = input} placeholder="Link for application" />
					<div className="button" onClick={this.publishJob}>Add job</div>
				</div>
			)}/>
    )
  }
}

AddJob.propTypes = {
	opened: PropTypes.bool.isRequired,
	handleClose: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/AddJob.js